import { useTranslation } from 'react-i18next';
import { ModalScreenPension } from '../../../general/ModalScreen';
import { OverlayHeader } from '../../OverlayHeader';
import { PrintButton } from '../PrintButton';
import React, { useContext } from 'react';
import { PensionContext } from '../../../../contexts/pension-robot/PensionContext';
import { isPensionCalculatedTogether } from '../../../../utils/functions';

export const SaveMyBNDModal: React.FC<{
    isShown: boolean;
    setIsShown: (val: boolean) => void;
}> = ({ isShown, setIsShown }) => {
    const { t } = useTranslation('pension');
    const {
        parameters: { general, personalInfo },
    } = useContext(PensionContext);

    const withPartner = isPensionCalculatedTogether(personalInfo);

    const onClose = () => setIsShown(false);

    return (
        <ModalScreenPension isShown={isShown} useStdModalStyle={false} className="mx-auto md:max-w-screen-sm">
            <div className={'bg-white md:mx-auto md:rounded-xl p-8 flex flex-col gap-4'}>
                <OverlayHeader title={t('pension-save-mybnd-modal-title')} onClose={onClose} />
                <span>{t('pension-save-mybnd-modal-text1')}</span>
                <span>{t('pension-save-mybnd-modal-text2')}</span>
                <PrintButton buttonText={t('pension-save-mybnd-modal-button')} buttonClassName={'h-10 mt-4'} />
                {withPartner && (
                    <span className={'italic text-sm'}>
                        {!!general.startFromPartnerPensionAge
                            ? t('pension-save-mybnd-modal-disclaimer-own')
                            : t('pension-save-mybnd-modal-disclaimer-partner')}
                    </span>
                )}
            </div>
        </ModalScreenPension>
    );
};
